export const FEATURE_NAME = '@zerops/zerops/feature/dns-check-status-pop';
